import { Component } from '@angular/core';
import { environment } from '~environment';

const REALPAGE_LOGO = `${environment.staticFiles}/images/realpage-logo-white.png`;
@Component({
  selector: 'terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.scss']
})

export class TermsOfUseComponent {
  rpLogo = REALPAGE_LOGO;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/terms-of-use.component.ts